import {ApiService} from './api.service';

/**
 * DirectoryService
 */
export const DocumentService = {
    documentBaseURI: 'documents',
    tagBaseURI: 'tags',

    add(payload, config) {
        let formData = new FormData();
        for (let i in payload) {
            formData.append(i, payload[i]);
        }

        return ApiService.postForm(this.documentBaseURI + '/', formData, config);
    },

    addTags(payload) {
        return ApiService.post(this.documentBaseURI + '/' + payload.documentSlug + '/tags', {
            tags: payload.tags
        });
    },

    delete(documentSlug) {
        return ApiService.delete(this.documentBaseURI + '/' + documentSlug);
    },

    fetchTags() {
        return ApiService.get(this.tagBaseURI + '/');
    },

    invalidateCache(document) {
        let hash = Math.random().toString(36).substr(2, 10);
        document.path += '?' + hash;
        document.thumbnailPath += '?' + hash;

        return document;
    },

    isImage(document) {
        return document && 'thumbnailPath' in document && document.thumbnailPath;
    },

    isMedia(document) {
        return this.isVideo(document) || this.isImage(document);
    },

    isVideo(document) {
        // Désactivation temporaire : Chrome ne prend pas en charge les mp4 h264
        return false;

        // let videoExt = ['avi', 'mp4'];
        // let ext = this.getDocumentExt(document);
        // return videoExt.indexOf(ext) !== -1;
    },

    getDocumentExt(document) {
        let parts = document.path.split('.');
        return parts && parts.length > 0 ? parts.pop().toLowerCase() : '';
    },

    regenerateThumbnail(documentSlug) {
        return ApiService.put(this.documentBaseURI + '/' + documentSlug + '/regenerate-thumbnail');
    },

    removeTag(payload) {
        return ApiService.delete(this.documentBaseURI + '/' + payload.documentSlug + '/' + payload.tagSlug);
    },

    rotate(payload) {
        return ApiService.put(this.documentBaseURI + '/' + payload.documentSlug + '/rotate', {
            angle: payload.angle
        });
    },

    searchByTags(tagsSlug) {
        return ApiService.post(this.documentBaseURI + '/' + 'search', {
            tags: tagsSlug
        });
    }
};